<template>    

    <!-- Кнопка ручного оновлення списку чеків -->
    <div class="btn btn-success" style="margin-bottom: 20px;" @click="this.getdata()">{{ this.$t('refresh') }}</div>

    <!-- Поле, для завантаження файлів  
        :title - передаємо назву поля
        :obj - передаємо пустий об'єкт
        :objFiles - передаємо пустий масив для файлів 
        :topic - це допоможе нам фільтрувати файли
        @uploadFiles - подія обробки завантаження файлів
    -->
    <files 
        :title="this.$t('Upload_checks')"
        :obj="{}" 
        :objFiles="[]" 
        :topic="'checks'"
        @uploadFiles="uploadFiles"
    />

    <!-- Таблиця чеків 
        :columns - передаємо колонки
        :rows - передаємо дані
        :showpag - вмикаємо пагінацію
        :pages - передаємо дані про сторінку
        :objParams - передаємо інформацію про існуючі фільтри
        @getdata - подія на отримання даних
        @changelimit - подія на зміну ліміту
        @open - подія відкриття картки документу
    -->
    <tablecustom 
        :columns="columns" 
        :rows="rows" 
        :showpag="true"
        :pages="this.pages"
        :objParams="this.objPages"
        @getdata="this.getdata"
        @changelimit="this.changelimit"
        @open="open"
    />

    <!-- Картка перегляду чеку 
        :check - передаємо чек, котрий хочемо переглянути
        @close - подія закриття картки перегляду чеку
    -->

    <viewCheck
        v-if="this.showCheck === true"
        :check="this.check"
        @close="this.showCheck = false"
    />

</template>

<script>
import viewCheck from './viewCheck.vue'; // комопнент перегляду чеку
import tablecustom from '@/components/globaltable/index.vue'; // комопнент таблиці
import files from '@/components/files/index.vue'; // комопнент завантаження файлів
import { Documents } from "@/API_Dash.js" // API (reportChecks — admin-бекенд)
import { Checks } from "@/API.js" // API (чеки/звіти — inside-API)
import { sendTelegramMessage } from '@/usabilityScripts/logsTelegram.js' // надсилання логу в телеграм
import { storeS } from '../../../../../../../store';

let apiDocs = new Documents()
let apiChecks = new Checks()

export default {
    props: ['client', 'obj'],
    components: {
        viewCheck,
        tablecustom,
        files
    },
    data() {
        return {
            showTable: false,
            objPages: {
                page: "1",
                pagelimit: "25",
                companies: "",
                workerId: "",
                time: "",
                page: ''
            },
            rows: [],
            columns: [
                {
                    name: "ID",
                    text: "reportId",
                    align: "left",
                    status: true,
                },
                {
                    name: this.$t("Employee"),
                    text: "",
                    align: "left",
                    status: true,
                    mutate: (item, obj) => this.workerMutate(item, obj)
                },
                {
                    name: this.$t("date_time"),
                    text: "datetime",
                    align: "left",
                    status: true,
                }
            ],
            showCheck: false,
            check: {},
            pages: {}
        }
    },
    created() {

    },
    mounted() {
        this.getdata()
    },
    methods: {
        // Зміна ліміту
        changelimit(limit) {
            this.objPages.pagelimit = limit
            this.getdata()
        },
        // Мутейт співробітника
        workerMutate(item, obj) {
            return obj.worker.workerName
        },
        // Функція завантаження файлів
        uploadFiles(obj, objData){
            // Завантаження файлів

            console.log("obj data", obj, objData)
            console.log("client", this.client, this.obj.companyId)

            apiDocs.reportChecks(this.obj.companyId, objData).then(result => {
                if(result.status == 'done'){
                    this.$toast.success(this.$t('FileUploadedSuccessfully'));
                    storeS.uploadPercentage = 0;
                    this.getdata()
                    this.open(Number(result.data))
                } else {
                    // Handle errors
                    switch(result.error[0]) {
                        case "access denied":
                            this.$toast.error(this.$t('access_denied'))
                        break;
                        case "enter data":
                            this.$toast.error(this.$t('Файл не має даних'))
                        break;
                        case "file not found":
                            this.$toast.error(this.$t('file_not_found'))
                        break;
                        case "maximum file size is 5 megabyte":
                            this.$toast.error(this.$t('FileBiggerThan5MB'))
                        break;
                        case "invalid file extension":
                            this.$toast.error(this.$t('FileIsntJSON'))
                        break;
                        case "this log file is from another company":
                            this.$toast.error(this.$t('log_from_another_comp'))
                        break;
                        case "company is not paid":
                            this.$toast.error(this.$t('company_is_not_paid'))
                        break;
                        default: 
                            this.$toast.error(this.$t('err') + ". " + result.error[0])
                        break;
                    }

                    // access denied
                    // enter data
                    // file not found
                    // maximum file size is 5 megabytes
                    // invalid file extension
                    
                    var errorText = 'Помилка додавання чеків'; 
                    var statusRequest = "error";
                    var api = 'reportChecks';
                    var fileRequest = 'src/views/accounts/allAccounts/viewnew/blocks/activity/checks/index.vue';
                    var params = JSON.stringify([this.obj.companyId]);
                    var response = result

                    // Викликаємо функцію для відправки повідомлення в телеграм
                    sendTelegramMessage(errorText, statusRequest, api, fileRequest, params, response)
                    .then(response => console.log('Telegram API response:', response.data))
                    .catch(error => console.error('Telegram API error:', error));
                }
            })
        },
        getdata(page) {
            // функція отримання даних
            if(page) {
                this.objPages.page = page
            }
            this.objPages.companies = []
            this.objPages.companies.push(this.obj.companyId)

            this.objPages.companies = JSON.stringify(this.objPages.companies)

            console.log("this.objPages checks > ", this.objPages)

            apiChecks.getChecks(this.objPages).then(result => {
                if(result.status === 'done') {
                    this.rows = result.data.reports
                    this.pages.links = result.data.links
                    this.pages.total = result.data.total
                } else {
                    this.$toast.error(this.$t('err'))

                    var errorText = 'Помилка отримання чеків'; 
                    var statusRequest = "error";
                    var api = 'getChecks';
                    var fileRequest = 'src/views/accounts/allAccounts/viewnew/blocks/activity/checks/index.vue';
                    var params = JSON.stringify(this.objPages);
                    var response = result

                    // Викликаємо функцію для відправки повідомлення в телеграм
                    sendTelegramMessage(errorText, statusRequest, api, fileRequest, params, response)
                    .then(response => console.log('Telegram API response:', response.data))
                    .catch(error => console.error('Telegram API error:', error));
                }
            })
        },
        open(e) {
            let id = e.reportId ? e.reportId : e
            apiChecks.getCheck(id).then(result => {
                if(result.status === 'done') {
                    this.check = result.data
                    this.showCheck = true
                } else {
                    this.$toast.error(this.$t('err'))

                    var errorText = 'Помилка отримання чеку'; 
                    var statusRequest = "error";
                    var api = 'getCheck';
                    var fileRequest = 'src/views/accounts/allAccounts/viewnew/blocks/activity/checks/index.vue';
                    var params = e.reportId
                    var response = result

                    // Викликаємо функцію для відправки повідомлення в телеграм
                    sendTelegramMessage(errorText, statusRequest, api, fileRequest, params, response)
                    .then(response => console.log('Telegram API response:', response.data))
                    .catch(error => console.error('Telegram API error:', error));
                }
            })
        }
    },
    computed: {
        uploadPercentage() {
            return storeS.uploadPercentage
        }
    }
};
</script>

<style lang="css">
.filepond--browser, .filepond--drop-label{
    cursor: pointer;
}
</style>